
<section>
<!--    Print Report Button to the left-->
    <div class="flex justify-end items-center gap-4">
        <button class=" p-2 rounded-lg bg-blue-500 m-2.5 text-white" (click)="exportWithCustomOptions()">Export PDF</button>
    </div>

    <!-- Progress Bar (shown only when exporting) -->
    <div *ngIf="isExporting" class="mb-4 px-10 p-3 bg-gray-50 border border-gray-200 rounded-lg">
        <div class="flex justify-between items-center mb-2">
            <span class="text-sm font-medium text-gray-700">Exporting PDF...</span>
            <span class="text-sm font-semibold text-green-600">{{ exportProgress }}%</span>
        </div>
        <div class="w-full bg-gray-200 rounded-full h-2 overflow-hidden">
            <div
                class="bg-gradient-to-r from-green-500 to-green-600 h-2 rounded-full transition-all duration-300 ease-out relative overflow-hidden animate-shimmer"
                [style.width.%]="exportProgress">
            </div>
        </div>
<!--        <div class="text-xs text-gray-500 mt-1">{{ progressMessage }}</div>-->
    </div>

    <!-- insurance-risk-report.component.html -->
    <div class="print-container">
        <!-- Header Section -->
        <div class="header-section">
            <div class="company-info">
                <img src="assets/reinsurance/icz-logo-bm.png" alt="ICZ Logo" class="company-logo">
                <div class="company-details">
                    <h1>NEGATIVE MARKET SLIP REPORT</h1>
                    <p class="report-subtitle">Insurance Risk Data & Reinsurance Offers</p>
                </div>
            </div>
            <div class="qr-section">
                <qr-code value="{{baseUrl}}negative-market-slip/verify?slipNumber={{riskData.reinsuranceSlipNumber}}" size="150" errorCorrectionLevel="M"></qr-code>
                <p class="qr-label">Scan for Verification</p>
            </div>
        </div>

        <!-- Risk Details Section -->
        <div class="risk-details-section">
            <h2>Risk Details</h2>
            <div class="details-grid">
                <!-- Left Column -->
                <div class="details-column">
                    <div class="detail-item">
                        <span class="label">Insurance Slip Number:</span>
                        <span class="value">{{ riskData.reinsuranceSlipNumber }}</span>
                    </div>
                    <div class="detail-item">
                        <span class="label">Insured Customer/Company:</span>
                        <span class="value">{{ riskData.reinsuranceInsuredCustomerCompanyName }}</span>
                    </div>
                    <div class="detail-item">
                        <span class="label">Type and Extent of Cover:</span>
                        <span class="value">{{ riskData.reinsuranceTypeExtentCoverGranted }}</span>
                    </div>
                    <div class="detail-item">
                        <span class="label">Insurer's Policy Number:</span>
                        <span class="value">{{ riskData.reinsurancePolicyNumber }}</span>
                    </div>
                    <div class="detail-item">
                        <span class="label">Situation/Territorial Scope:</span>
                        <span class="value">{{ riskData.reinsuranceSituationTerritorialScope }}</span>
                    </div>
                    <div class="detail-item">
                        <span class="label">Re-insurers Commission:</span>
                        <span class="value">{{ riskData.reinsuranceCommission }}</span>
                    </div>
                    <div class="detail-item">
                        <span class="label">Aggregate Per Class:</span>
                        <span class="value">{{ riskData.reinsuranceAggregatePerClass }}</span>
                    </div>
                    <div class="detail-item">
                        <span class="label">Premium:</span>
                        <span class="value">${{ riskData.reinsuranceRiskPremiumAmount | number:'1.2-2' }}</span>
                    </div>
                </div>

                <!-- Right Column -->
                <div class="details-column">
                    <div class="detail-item">
                        <span class="label">Start Date of Re-insurance:</span>
                        <span class="value">{{ riskData.reinsuranceStateDateOfReinsurance | date:'shortDate' }}</span>
                    </div>
                    <div class="detail-item">
                        <span class="label">End Date of Re-insurance:</span>
                        <span class="value">{{ riskData.reinsuranceEndDateOfReinsurance | date:'shortDate' }}</span>
                    </div>
                    <div class="detail-item">
                        <span class="label">Transaction Date:</span>
                        <span class="value">{{ riskData.reinsuranceTransactionDate | date:'shortDate' }}</span>
                    </div>
                    <div class="detail-item">
                        <span class="label">Total Sum Insured:</span>
                        <span class="value">${{ riskData.reinsuranceTotalSumInsured | number:'1.2-2' }}</span>
                    </div>
                    <div class="detail-item">
                        <span class="label">Facultative Offer:</span>
                        <span class="value">${{ riskData.reinsuranceFacultativeOffer | number:'1.2-2' }}</span>
                    </div>
                    <div class="detail-item">
                        <span class="label">Limit of Liability:</span>
                        <span class="value">${{ riskData.reinsuranceLimitOfLiability | number:'1.2-2' }}</span>
                    </div>
                    <div class="detail-item">
                        <span class="label">Gross Retention:</span>
                        <span class="value">{{ riskData.reinsuranceGrossRetention }}</span>
                    </div>
                    <div class="detail-item">
                        <span class="label">Net Retention:</span>
                        <span class="value">{{ riskData.reinsuranceNetRetention }}</span>
                    </div>
                </div>
            </div>
        </div>

        <!-- Offers Section -->
        <div class="offers-section">
            <h2>Reinsurance Offers</h2>
            <div class="table-container">
                <table class="offers-table">
                    <thead>
                    <tr>
                        <th>Slip Number</th>
                        <th>Transaction Date</th>
                        <th>Client</th>
                        <th>Reinsurer</th>
                        <th>Limit of Liability</th>
                        <th>Facultative Offer</th>
                        <th>Premium</th>
                        <th>Gross Retention</th>
                        <th>Net Retention</th>
                        <th>Offer %</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr *ngFor="let offer of offersData">
                        <td>{{ offer.reinsuranceSlipNumber }}</td>
                        <td>{{ offer.transactionDate | date:'shortDate' }}</td>
                        <td>{{ offer.client }}</td>
                        <td>{{ offer.reinsurer }}</td>
                        <td>${{ offer.limitOfLiability | number:'1.2-2' }}</td>
                        <td>${{ offer.facultativeOffer | number:'1.2-2' }}</td>
                        <td>${{ offer.premium | number:'1.2-2' }}</td>
                        <td>${{ offer.grossRetention | number:'1.2-2' }}</td>
                        <td>${{ offer.netRetention | number:'1.2-2' }}</td>
                        <td>{{ offer.offerPercentage }}</td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <!-- Footer -->
        <div class="footer-section">
            <p class="generated-date">Report Generated: {{ currentDate | date:'full' }}</p>
            <p class="disclaimer">This is a system-generated report. For verification, scan the QR code above.</p>
        </div>
    </div>

<!--    Footer-->
    <footer class="flex items-center justify-center">
        <div class="flex items-center justify-end gap-4 p-4 text-gray-500 max-w-screen-2xl w-full">
            <p>&copy; {{ currentYear }} ICZ. All rights reserved.</p>
            <a href="https://www.smatechgroup.com/" >Powered by Smatech Group</a>
        </div>
    </footer>
</section>

